/**
 * ConsentExplainerCard — Static privacy explainer.
 *
 * Never interactive. Rendered at the top of the Practitioner Access screen.
 * Left purple border signals the privacy/security context.
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from '@dramadetector/shared';
import { GlassCard } from '../../glass';

export const ConsentExplainerCard: React.FC = () => {
  const { t } = useTranslation('practitioner_consent');

  const body = t('explainer.body');
  // Split on "private by default" for bold emphasis
  const boldPhrase = 'private by default';
  const boldIdx = body.indexOf(boldPhrase);

  return (
    <GlassCard
      withChromeBorder={false}
      noPadding
      style={styles.card}
    >
      <View style={styles.row}>
        <View style={styles.iconContainer} accessibilityElementsHidden={true}>
          <Text style={styles.icon}>🛡️</Text>
        </View>
        <Text style={styles.body}>
          {boldIdx === -1 ? (
            body
          ) : (
            <>
              {body.slice(0, boldIdx)}
              <Text style={styles.bold}>{boldPhrase}</Text>
              {body.slice(boldIdx + boldPhrase.length)}
            </>
          )}
        </Text>
      </View>
    </GlassCard>
  );
};

const styles = StyleSheet.create({
  card: {
    borderLeftWidth: 3,
    borderLeftColor: '#A78BFA',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  iconContainer: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: 'rgba(167, 139, 250, 0.12)',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: 2,
  },
  icon: {
    fontSize: 14,
  },
  body: {
    flex: 1,
    fontSize: 14,
    color: '#71717A',
    lineHeight: 20,
  },
  bold: {
    fontWeight: '600',
    color: '#71717A',
  },
});
